import axios from "axios";
import {YOUTUBE_API_URL} from "@/common/config";

function init() {
    return axios.create({
        baseURL: YOUTUBE_API_URL,
        //timeout: 10000
    });
};

const Api = {
    get(resource, params = null) {
        return init().get(resource, params)/*.catch(error => {
            throw new Error(`ApiService ${error}`);
        });*/
    },
};

export default Api;